import { LoadingButton } from '@mui/lab';
import { SubmitHandler, useForm } from 'react-hook-form';
import DefaultCard from 'src/backoffice-app-code/components/cards/DefaultCard';
import {
  FormProvider,
  RHFSelect,
  RHFTextField,
} from 'src/backoffice-app-code/components/react-hook-form';
import { useSendNotificationToAllUsers } from '../../../application';
import RHFTextFieldMultiline from 'src/backoffice-app-code/components/react-hook-form/RHFTextFieldMultiline';
import DefaultSingleColumnBox from 'src/backoffice-app-code/components/boxs/DefaultSingleColumnBox';
import { PushNotificationOptions, SendNotificationToAllUsersFormData } from '../../../models';
import { Grid } from '@mui/material';

export const SendNotificationToAllUsersPageForm: React.FC = () => {
  const { isLoading, sendNotification } = useSendNotificationToAllUsers();

  const methods = useForm<SendNotificationToAllUsersFormData>();
  const { handleSubmit, reset } = methods;

  const onSubmit: SubmitHandler<SendNotificationToAllUsersFormData> = async (data) => {
    await sendNotification(data);
    reset();
  };

  return (
    <Grid container>
      <Grid item xs={12} md={10}>
        <DefaultCard cardHeaderText="Pošaljite notifikaciju svim korisnicima">
          <FormProvider {...{ methods }} onSubmit={handleSubmit(onSubmit)}>
            <DefaultSingleColumnBox>
              <RHFTextField name="title" label="Naslov" />
              <RHFTextFieldMultiline name="body" label="Sadržaj" />
              <RHFSelect name="type" label="Tip" options={PushNotificationOptions} />
              <LoadingButton variant="contained" loading={isLoading} type="submit">
                Pošalji
              </LoadingButton>
            </DefaultSingleColumnBox>
          </FormProvider>
        </DefaultCard>
      </Grid>
    </Grid>
  );
};
